import { QUESTIONS } from "@/lib/questions";

const OPTION_LABELS = Object.fromEntries(
  Object.values(QUESTIONS).flat().flatMap((q) => (q.options || []).filter((o) => o && o.value).map((o) => [o.value, o.label]))
);

const label = (v) => OPTION_LABELS[v] || v;

export const productForm = (p) => {
  const forms = p.form_admin?.length ? p.form_admin : p.form ? [p.form] : [];
  return forms.filter(Boolean).map(label).join(", ");
};

export const productApplication = (p) => p.application || "";
